import React, { FC } from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';
import { useUrlForPageId } from '../../../../app/pages/ui/utils/useUrlForPageId';
import { ParkingPageId } from '../../../domain/pages/ParkingPageId';
import { Extras } from '../../booking-steps/extras/Extras';
import { BookingPageLayout } from '../shared/BookingPageLayout';

export const NewBookingExtrasPage: FC = () => {
	const { t } = useTranslation();
	const parentUrl = useUrlForPageId(ParkingPageId.NewBookingAvailability);
	const nextUrl = useUrlForPageId(ParkingPageId.NewBookingDetails);

	return (
		<BookingPageLayout
			parentUrl={parentUrl}
			parentTitle={t('web_parking_extras_back_button')}
			title={t('web_parking_extras_header')}
		>
			<Extras nextUrl={nextUrl} />
		</BookingPageLayout>
	);
};
